// JOBE-0044.4: FilterChip — one chip. Two-line stacked (predicate top,
// values bottom). The mandatory scope chip carries `kind: 'scope'` and
// renders a `·` non-affordance in place of the `×`; predicate chips
// carry a real `×`.
//
// JOBE-0044.10: predicate chips accept an `onEdit` prop. Clicking the
// chip body (NOT the `×`) calls `onEdit` and the host re-opens the
// matching value sub-popover anchored to this chip. The chip's outer
// span is forwarded via `anchorRef` so the popover can position
// itself.

import { forwardRef } from 'react';

export const FilterChip = forwardRef(function FilterChip(
  { chip, onRemove, onEdit },
  ref,
) {
  if (chip.kind === 'scope') {
    return (
      <span
        ref={ref}
        className="library-chip library-chip-scope"
        aria-label="scope chip (mandatory)"
      >
        <span className="library-chip-label">scope</span>
        <span className="library-chip-value">{chip.label || 'Everything I can read'}</span>
        <span
          className="library-chip-lock"
          title="Scope is mandatory"
          aria-label="Scope is mandatory"
        >·</span>
      </span>
    );
  }
  const onBodyClick = (e) => {
    if (!onEdit) return;
    // Don't intercept clicks on the × — let onRemove fire.
    if (e.target?.closest && e.target.closest('.library-chip-remove')) return;
    onEdit();
  };
  return (
    <span
      ref={ref}
      className="library-chip library-chip-predicate"
      onClick={onBodyClick}
      role={onEdit ? 'button' : undefined}
      tabIndex={onEdit ? 0 : undefined}
      onKeyDown={(e) => {
        if (!onEdit) return;
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onEdit();
        }
      }}
      aria-label={onEdit ? `Edit ${chip.friendlyToken} filter` : undefined}
    >
      <span className="library-chip-label">{chip.friendlyToken}</span>
      <span className="library-chip-value">{(chip.values || []).join(', ')}</span>
      <button
        type="button"
        className="library-chip-remove"
        onClick={(e) => { e.stopPropagation(); onRemove?.(); }}
        aria-label={`Remove ${chip.friendlyToken} filter`}
      >×</button>
    </span>
  );
});
